import { render, staticRenderFns } from "./productDetails.vue?vue&type=template&id=36cf6217&scoped=true&"
import script from "./productDetails.vue?vue&type=script&lang=js&"
export * from "./productDetails.vue?vue&type=script&lang=js&"
import style0 from "./productDetails.vue?vue&type=style&index=0&id=36cf6217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf6217",
  null
  
)

export default component.exports